import { render, staticRenderFns } from "./DetailMasterDataRole.vue?vue&type=template&id=4b0e20e2"
import script from "./DetailMasterDataRole.vue?vue&type=script&lang=js"
export * from "./DetailMasterDataRole.vue?vue&type=script&lang=js"
import style0 from "./DetailMasterDataRole.vue?vue&type=style&index=0&id=4b0e20e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports